<template>
	<div>
		<div class="contentBigBox">
			<div class="details-title">
				<div>{{taskListTitle.name}}</div>
				<div><span> 抽样类型: {{taskListTitle.categoryName}}</span></div>
			</div>
			<div class="details-smalltitle">
				{{reviewName.name}}抽样报告(共{{totalsecond}}份)
			</div>
			<el-row :gutter="30" v-loading="loading">
				<el-col :span='tootipType?12:24'>
					<el-table class="qcTable haveFilterTable" ref="multipleTable" :data="reportListByTaskVal" highlight-current-row
					 @filter-change="filterTagTable">
						<el-table-column width="140" prop="HospitalName" label="中心名称" :filters="secondListFiltersOrganization" column-key="HospitalUid"
						 show-overflow-tooltip></el-table-column>
						<el-table-column prop="ModalityType" label="审核医生" v-if="reviewName.SubjectType == 2">
							<template slot-scope="scope">
								<span>{{scope.row.FirstApproverName}}</span>
							</template>
						</el-table-column>
						<el-table-column prop="ModalityType" label="影像技师" v-if="reviewName.SubjectType == 3">
							<template slot-scope="scope">
								<span>{{scope.row.TechnictionName}}</span>
							</template>
						</el-table-column>
						<el-table-column prop="ModalityType" label="诊断医生" v-if="reviewName.SubjectType == 4">
							<template slot-scope="scope">
								<span>{{scope.row.ReportSubmitterName}}</span>
							</template>
						</el-table-column>
						<el-table-column prop="AccNo" min-width="100" label="报告编号" show-overflow-tooltip></el-table-column>
						<el-table-column prop="ModalityType" column-key='ModalityType' min-width="100" :filters="secondListFiltersType"
						 label="设备类型"></el-table-column>
						<el-table-column prop="CheckingItems" min-width="120" label="检查项目" show-overflow-tooltip></el-table-column>
						<el-table-column prop="ReportScore" label="报告评分" key='1' v-if="taskInfo.CategoryName=='报告'||taskInfo.CategoryName=='影像和报告'"></el-table-column>
						<el-table-column prop="ReportScoreDiff" label="报告分差" key='2' v-if="thisOnly&&(taskInfo.CategoryName=='报告'||taskInfo.CategoryName=='影像和报告')"></el-table-column>
						<el-table-column prop="ImageScore" label="影像评分" key='3' v-if="taskInfo.CategoryName=='影像'||taskInfo.CategoryName=='影像和报告'"></el-table-column>
						<el-table-column prop="ImgScoreDiff" label="影像分差" key='4' v-if="thisOnly&&(taskInfo.CategoryName=='影像'||taskInfo.CategoryName=='影像和报告')"></el-table-column>
						<el-table-column prop="QCTimes" label="质控进度" key='5' v-if="thisOnly&&(taskInfo.DistributionMethod!=''&&taskInfo.DistributionMethod!='未知'&&taskInfo.DistributionMethod!='null')">
							<template slot-scope="scope">
								<el-tooltip effect="dark" placement="top-start">
									<div class="progress">
										<div class="progress-bar progress-bar-success" :style="`width: ${Math.floor((scope.row.CompleteCount/scope.row.QCTimes)*100)}%`">
										</div>
										<span class="sr-only">{{(Math.floor((scope.row.CompleteCount/scope.row.QCTimes)*100))}}%</span>
									</div>
									<div slot="content" class="tableTooltip">
										<div>
											<em></em>
											<span>已完成数量:{{scope.row.CompleteCount}}</span>
										</div>
									</div>
								</el-tooltip>
							</template>
						</el-table-column>
						<el-table-column prop="Status" label="质控状态" column-key='Status' min-width="100" :filters="secondListFiltersStatus">
							<template slot-scope="scope">
								<div v-if="scope.row.TotalStatus == 0">
									<span>{{scope.row.Status | formatStatus}}</span>
								</div>
								<div v-else-if="scope.row.Status == 0">
									<span>{{scope.row.TotalStatus | formatStatus}}</span>
								</div>
							</template>
						</el-table-column>
						<el-table-column prop="QCPeoPleName" min-width="100" label="专家姓名"></el-table-column>
						<el-table-column prop="QCDt" min-width="100" :formatter="formattertime" label="完成时间" show-overflow-tooltip></el-table-column>
						<el-table-column prop="" label="操作" fixed='right' width="180">
							<template slot-scope="scope">
								<span class="tableOpe" v-if="scope.row.TotalStatus<=123" @click="handleClick(scope.row,'table')">查看详情</span>
								<span class="tableOpe" v-else-if="scope.row.TotalStatus>123&&scope.row.ExpertUserGuids.length<=1"
								 @click="handleClick(scope.row,'length')">查看结果</span>
								<span class="tableOpe" v-else @click="handleCurrentChange(scope.row,scope.$index,$event)">查看结果</span>
								<span class="tableOpe marl10" v-if="(scope.row.TotalStatus==123)||(scope.row.Status == 123)||(scope.row.QCTimes<=1&&scope.row.TotalStatus == 125)||(scope.row.QCTimes<=1&&scope.row.Status == 125)" @click="changeClick(scope.row)">更换报告</span>
							</template>
						</el-table-column>
					</el-table>
				</el-col>
				<el-col v-show="tootipType" :span="12" class="exporttootip" :style="{minHeight:height}">
					<i ref="toopIcon" class="tootipCaretLeft el-icon-caret-left"></i>
					<div class="title">
						此报告有 {{qcresultsByTaskList.length}} 位专家参与质控 <i class="el-icon-close" @click="closeRbox"></i>
					</div>
					<ul class="qcresultsBox" :style="{height:height,minHeight:'85px'}">
						<li v-for="item in qcresultsByTaskList" :key="item.Name" class="qcresults">
							<el-row>
								<el-col :span='6'>
									专家 : {{item.Name}}  <i class="el-icon-finished dodgerBlue" v-if="item.IsSelected==1"></i> 
								</el-col>
								<el-col :span='6'>
									报告评分 : {{item.ReportScore}}
								</el-col>
								<el-col :span='6'>
									影像评分 : {{item.ImageScore}}
								</el-col>
								<el-col :span='6'>
									{{item.StatusName}}
								</el-col>
							</el-row>
							<el-row>
								<el-col :span='18'>
									完成时间 : {{item.QCDt}}
								</el-col>
								<el-col :span='6' class="tableOpe">
									<span @click="handleClick(item)">查看详情</span>
								</el-col>
							</el-row>
						</li>
					</ul>
				</el-col>
			</el-row>
			<div class="pages">
				<el-pagination class="pageAll" layout="prev, pager, next" v-anchor="1" :total="totalsecond" :page-size='pageIndex.Page'
				 :current-page='pageIndex.PageIndex' @current-change='currentChange'>
				</el-pagination>
			</div>
		</div>
	</div>
</template>

<script>
	// import { mapState, mapActions, mapMutations} from 'vuex'
	export default {
		data() {
			return {
				activeNames: ['1', '2'],
				active: 0,
				currentRow: null,
				height: 0,
				datas: {},
				thisOnly: false
			};
		},
		computed: {
			...Vuex.mapState('managerPlanList', ['secondListFiltersStatus', 'resultList', 'reviewName', 'qcresultsList',
				'qcresultsByTaskList', 'loading', 'reportListByTaskVal', 'secondListFiltersOrganization', 'secondListFiltersType',
				'totalsecond', 'pageIndex', 'taskListTitle', 'getExpertReportListParameter',
				'taskInfo', 'statusBar', 'SamplingTaskGuId','changeReportsList','GetCanChangableReportsParameter'
			]),
			...Vuex.mapState('breadcrumb', ['tootipType', 'selectRow']),
			lists() {
				this.thisOnly = this.reportListByTaskVal[0].ExpertUserGuids.length > 1 ? true : false;
				return this.reportListByTaskVal;
			}
		},
		filters: {
			formatStatus: function(value) {
				return {
					'': '不限',
					'120': '已抽样',
					'123': '已分配',
					'125': '进行中',
					'130': '已完成',
					'140': '申诉中',
					'170': '已归档'
				} [value] || '不限';
			}
		},
		watch: {
			lists(old) {
				let _this = this;
				if (this.selectRow.row != 1) {
					this.currentChangesSecond(this.selectRow.pageIndex);
					this.pageIndex.pageIndex = this.selectRow.pageIndex;
					this.pageshow = false;
					this.$nextTick(() => {
						_this.pageshow = true;
						_this.$refs.multipleTable.setCurrentRow(_this.reportListByTaskVal[_this.selectRow.index]);
					})
					if (_this.reportListByTaskVal) {
						this.GetQCResultsByTask({
							samplingtaskguid: _this.reportListByTaskVal[_this.selectRow.index].SamplingTaskGuid,
							reportGuid: _this.reportListByTaskVal[_this.selectRow.index].ReportGuid
						})
					}
				} else {
					this.currentChangesSecond(1);
					this.$refs.multipleTable.setCurrentRow();
				}
			}
		},
		activated() {
			this.getExpertReportListParameter.statusList = '';
			this.GetExpertReportList();
			this.$refs.multipleTable.clearFilter();
		},
		methods: {
			...Vuex.mapMutations('breadcrumb', ['setqcresultsShow', 'setTootipType']),
			...Vuex.mapMutations('managerPlanList', ['setLoading', 'currentChangesSecond','changeReportsListMu']),
			...Vuex.mapMutations('doctor', ['setDetailsParameter', 'setDetalLoading']),
			...Vuex.mapActions('managerPlanList', ['GetQCResultsByTask', 'GetExpertReportList']),
			...Vuex.mapActions('doctor', ['GetReportDetail']),
			changeClick(row){
				row.SubjectType = this.reviewName.SubjectType;
				this.GetCanChangableReportsParameter.pageIndex = 1;
				this.changeReportsListMu(row);
				this.$router.push("/home/manager/task/replacementReport");
			},
			closeRbox() {
				this.setTootipType(false);
				this.$refs.multipleTable.setCurrentRow();
			},
			// 右侧出现专家列表
			handleCurrentChange(val, index, e) {
				this.currentRow = val;
				this.selectRow.index = index;
				this.selectRow.row = val;
				let target = e.target || e.originalTarget || e.toElement || e.path[0];
				let parent = e.currentTarget.parentElement.parentElement;
				if (target.tagName == "SPAN" || target.nodeName == "SPAN") {
					this.setTootipType(true);
					this.datas.ReportGuid = val.ReportGuid;
					this.datas.SamplingTaskGuid = val.SamplingTaskGuid;
					this.GetQCResultsByTask({
						samplingtaskguid: val.SamplingTaskGuid,
						reportGuid: val.ReportGuid
					})
					let difference = parent.offsetHeight / 2;
					this.$refs.toopIcon.style.top = parent.offsetTop + difference + 35 + 'px';
					let ele = document.getElementsByClassName('qcTable')[0];
					if (ele) {
						this.height = (ele.offsetHeight) - 60 + 'px';
					}
				}
			},
			// 跳转至详情页
			handleClick(val) {
				let arg = arguments[1];
				this.qcresultsList.Name = val.Name;
				if (arg) {
					this.setqcresultsShow(false);
					this.qcresultsList.expertUserId = val.ExpertUserGuids[0];
					this.qcresultsList.ReportGuid = val.ReportGuid;
					this.qcresultsList.SamplingTaskGuid = val.SamplingTaskGuid;
				} else {
					this.setqcresultsShow(true);
					this.qcresultsList.expertUserId = val.ExpertUserId;
					this.qcresultsList.ReportGuid = this.datas.ReportGuid;
					this.qcresultsList.SamplingTaskGuid = this.datas.SamplingTaskGuid;
				}
				// this.setDetalLoading(true);
				this.setDetailsParameter({
					reportGuid: this.qcresultsList.ReportGuid,
					samplingTaskGuid: this.qcresultsList.SamplingTaskGuid,
					ExpertUserGuid: this.qcresultsList.expertUserId
				})
				this.GetQCResultsByTask({
					samplingtaskguid: this.qcresultsList.SamplingTaskGuid,
					reportGuid: this.qcresultsList.ReportGuid
				})

				// this.GetReportDetail()
				this.$router.push("/home/manager/scoring");
				document.body.scrollTop = document.documentElement.scrollTop = 0;
			},
			formattertime(row, column, cellValue) {
				if (cellValue != '' && cellValue != null) {
					return cellValue.substring(0, cellValue.length - 3);
				} else {
					return cellValue;
				}

			},
			//分页
			currentChange(val) {
				this.setLoading(true);
				this.selectRow.pageIndex = val;
				this.selectRow.row = val;
				this.setTootipType(false);
				this.currentChangesSecond(val)
				this.GetExpertReportList();
			},
			filterTagTable(filters) {
				this.currentChangesSecond(1);
				this.setTootipType(false);
				let statusList = '';
				let HospitalUid = [],
					DoctorType = [],
					ModalityType = [],
					Status = []
				if (filters.HospitalUid) {
					this.$refs.multipleTable.clearFilter(['ModalityType', 'Status']);
					HospitalUid = filters.HospitalUid.join(',')
				}
				if (filters.DoctorType) {
					DoctorType = filters.DoctorType.join(',')
				}
				if (filters.ModalityType) {
					this.$refs.multipleTable.clearFilter(['HospitalUid', 'Status']);
					ModalityType = filters.ModalityType.join(',')
				}
				if (filters.Status) {
					this.$refs.multipleTable.clearFilter(['HospitalUid', 'ModalityType']);
					Status = filters.Status.join(',')
				}
				this.getExpertReportListParameter.statusList = Status
				if (HospitalUid && HospitalUid != "") {
					this.getExpertReportListParameter.KeyName = HospitalUid
					this.getExpertReportListParameter.statusList = '';
				}
				if (ModalityType && ModalityType != "") {
					this.getExpertReportListParameter.KeyName = ModalityType
					this.getExpertReportListParameter.statusList = '';
				}
				// this.getExpertReportListParameter.Status = Status
				
				this.setLoading(true);
				this.GetExpertReportList();
			},

		}

	}
</script>
<style scoped>
	.contentBigBox {
		padding-top: 36px;
	}

	.haveFilterTable>>>.el-icon-arrow-down:before {
		content: "\e791" !important;
	}
</style>
